module.exports = __webpack_public_path__ + "img/token-menu.a5ebb8de.svg";